import React from "react";
import Footer from "../../components/Footer/Footer";
import NavbarContained from "../../components/NavbarContained/NavbarContained";
import styles from "./Contact.module.css";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Button, TextField, Typography } from "@mui/material";
import { UniversalContext } from "../../context/UniversalContext/UniversalContext";

const Contact = () => {
    const { contactUsModal, setContactUsModal, setAlert } = React.useContext(UniversalContext);
    const [open, setOpen] = React.useState(contactUsModal);
    const [name, setName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [buttonVariant, setButtonVariant] = React.useState("disabled");
    const handleClose = () => setContactUsModal(false);

    React.useEffect(() => {
        if (name && email && message) {
            setButtonVariant("contained");
        } else {
            setButtonVariant("disabled");
        }
    }, [name, email, message]);

    const formSubmitHandler = (e) => {
        e.preventDefault();
        console.log("Form submitted");
        console.log(name, email, message);
        handleClose();
        setAlert(true);
        setTimeout(() => {
            setAlert(false);
        }, 6000);
    };
    return (
        <>
            <NavbarContained />
            <h1 className={styles.heading}>Contact Us</h1>
            <div className={styles.para}>
                <h2 className={styles.heading2}>Reach Us</h2>
                <div className={styles.reach}>
                    <div>
                        <p>
                            <b>Address:</b> New Delhi, India.
                        </p>
                        <p>
                            <b>Phone:</b> +91 7762855749
                        </p>
                        <p>
                            <b>Email: &nbsp;</b>
                            <a href="mailto:ayurhom.team@gmail.com">ayurhom.team@gmail.com</a>
                        </p>
                    </div>
                    <div className={styles.socials}>
                        <InstagramIcon className={styles.icons} size="large" />
                        <FacebookIcon className={styles.icons} size="large" />
                        <YouTubeIcon className={styles.icons} size="large" />
                        <TwitterIcon className={styles.icons} size="large" />
                    </div>
                </div>
                </div>
                <div className={styles.para}>
                    <h2 className={styles.heading2}>Fill the form to get a call back!</h2>
                    <Typography
                        id="transition-modal-description"
                        sx={{ mt: 2 }}
                        className={styles.flexCol}
                    >
                        <form className={styles.form} onSubmit={formSubmitHandler}>
                            <TextField
                                className={styles.normalInput}
                                required
                                color="success"
                                id="outlined-required"
                                label="Name"
                                fullWidth
                                defaultValue=""
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField
                                className={styles.normalInput}
                                type="email"
                                color="success"
                                required
                                id="outlined-required"
                                label="Email"
                                fullWidth
                                defaultValue=""
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <TextField
                                className={styles.normalInput}
                                required
                                color="success"
                                id="outlined-multiline-static"
                                label="Message"
                                multiline
                                rows={4}
                                fullWidth
                                defaultValue=""
                                onChange={(e) => setMessage(e.target.value)}
                            />
                            <Button
                                variant={buttonVariant}
                                type="submit"
                                size="large"
                                color="success"
                                className={styles.modalButton}
                            >
                                Send Message
                            </Button>
                        </form>
                    </Typography>
                </div>
            <Footer />
        </>
    );
};

export default Contact;
